<template>
  <section class="footer">
    <div class="footer-title">
      <h2 class="footer-h2">N'attendez plus, réservez !</h2>
      <br />
      <h3 class="phone-number">
        03 25 80 37 31 <i class="fa-solid fa-phone"></i>
      </h3>
    </div>
    <div class="footer-menu">
      <div class="footer-contact">
        <h3>Contact</h3>
        <table>
          <tbody>
            <tr>
              <td>
                <i class="fa-solid fa-phone"></i>
              </td>
              <td><span> 03 25 80 37 31</span></td>
            </tr>
            <tr>
              <td>
                <i class="fa-solid fa-location-dot"></i>
              </td>
              <td>
                <span
                  >48 rue du Fort Saint-Georges <br />
                  10220 Géraudot</span
                >
              </td>
            </tr>
            <tr>
              <td>
                <i class="fa-brands fa-facebook"></i>
              </td>
              <td>
                <a
                  href="https://www.facebook.com/profile.php?id=100063190451556"
                >
                  La Pizza du Lac</a
                >
              </td>
            </tr>
            <tr>
              <td>
                <i class="fa-brands fa-instagram"></i>
              </td>
              <td>
                <a href="https://www.instagram.com/la_pizza_du_lac/"
                  >@la_pizza_du_lac</a
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="footer-navigate" v-show="!mobile">
        <h3>Navigation</h3>
        <ul>
          <li>
            <router-link class="link" :to="{ name: 'home' }"
              >Accueil</router-link
            >
          </li>
          <li>
            <router-link class="link" :to="{ name: 'menu' }">Menu</router-link>
          </li>
          <li>
            <router-link class="link" :to="{ name: 'contact' }"
              >Contact</router-link
            >
          </li>
        </ul>
      </div>
      <div class="footer-menus">
        <h3>Menu</h3>
        <ul>
          <li @click="downloadPDF('Pizza.pdf')">Pizza</li>
          <li @click="downloadPDF('BurgerGrillade.pdf')">Burger</li>
          <li @click="downloadPDF('menu2025.pdf')">Menu Complet</li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      mobile: null,
      windowWidth: null,
    };
  },
  created() {
    window.addEventListener("resize", this.checkScreen);
    this.checkScreen();
  },
  methods: {
    checkScreen() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth <= 900) {
        this.mobile = true;
        return;
      }
      this.mobile = false;
    },
    downloadPDF(filename) {
      const pdfUrl = `/menu/${filename}`;
      window.open(pdfUrl, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  width: 75%;
  height: 200px;
  justify-self: center;
  align-items: center;

  .footer-title {
    padding: 30px;
    h2 {
      font-weight: 300;
      font-size: clamp(20px, 3.5vw, 40px);
    }
    h3 {
      justify-self: center;
      left: 50%;
      font-weight: 200;
      font-size: clamp(16px, 2.5vw, 26px);
      width: 250px;
      border: 1px solid black;
      border-radius: 24px;
    }
  }

  .footer-menu {
    display: flex;
    justify-content: space-between;
    text-align: left;
    padding-bottom: 30px;

    li,
    .link {
      cursor: pointer;
      padding: 5px;
      color: #000;
      list-style: none;
      text-decoration: none;
    }

    h3 {
      padding: 7px;
      text-align: left;
    }

    .footer-contact {
      align-items: center;
      justify-content: center;

      td {
        padding: 5px;
        a {
          color: #000;
          text-decoration: none;
        }
      }
      @media (max-width: 800px) {
        font-size: small;
        td {
          padding: 2px;
        }
      }
    }

    .footer-navigate {
      position: absolute;
      left: 47%;
      text-align: center;
    }
  }
}
</style>